export const PageComponents = {
    install(Vue: any, opt: any) {
    }
};